import { render, staticRenderFns } from "./activity_child_wall.vue?vue&type=template&id=798e12fd&scoped=true"
import script from "./activity_child_wall.vue?vue&type=script&lang=js"
export * from "./activity_child_wall.vue?vue&type=script&lang=js"
import style0 from "./activity_child_wall.vue?vue&type=style&index=0&id=798e12fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798e12fd",
  null
  
)

export default component.exports